	export enum MenuQuantityItemEnum {
		Dashboard = 1,
		Scheduler = 100,
		Confirmation = 101,
		Reschedule = 102,
		WaitList = 103,
		FollowUp = 104,
		Appointments = 105,
		AppointmentRequests = 106,
		Recalls = 107,
		Patients = 200,
		Notes = 201,
		SalesOrders = 300,
		Billing = 400,
		Manufacturers = 500,
		ProductGroups = 501,
		ProductCategories = 502,
		Products = 503,
		PriceLists = 504,
		ReceiveInventory = 505,
		SerializedItems = 506,
		NonSerializedItems = 507,
		ReceivedInventoryOrders = 508,
		Marketing = 600,
		Campaigns = 601,
		Reports = 700,
		Admin = 800,
		WorkQueue = 900
	}
